export default {
  add_items: 'Tilføj varer',
  remove_items: 'Fjern varer',
  place_order: 'Afgiv ordre',
  proceed_to_payment: 'Fortsæt til betaling',
  go_to_menu: 'Gå til menu',

  toasts: {
    input_errors_found: 'Der er nogle problemer med dine ordreoplysninger',
  },

  error_messages: {
    internal_error: {
      title: 'Ordren mislykkedes 😔',
      description:
        'Der opstod desværre et uventet problem med din ordre. Vores tekniske team arbejder allerede på det 🛠️.',
    },
  },
};
